import dayjs from "dayjs";
import { FormEvent, useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Form, Row, ToggleButton } from "react-bootstrap";
import { toast } from "react-toastify";
import { defineCheckBoxInput, defineValueInInput, getValueFromInput, showInputErrorMsg } from "../../../../components/funcForInput";
import removeAllErrorMsg from "../../../../components/funcRemoveAllErros";
import funcSleep from "../../../../components/funcSleep";
import LoadingModal from "../../../../components/loadingModal";
import { ApiEndpoints, reqPatch, reqPostNew, reqPut } from "../../../../config/apiClient";
import stylesCheckbox from "../../../colaborador/styles/colaborador.module.css";

export default function Escala12x36Form({ escala, handleUpdate }: iProps) {
    useEffect(() => {
        if (Object.values(escala).length > 0) {
            carregarDados(escala);
        }
    }, [escala]);

    const [loading, setLoading] = useState<boolean>(false);

    const [registrarIntervalo, setRegistrarIntervalo] = useState<boolean>(true);
    const [calcularHorarioNoturno, setCalcularHorarioNoturno] = useState<number>(0);
    const [tipoDiurnoNoturno, setTipoDiurnoNoturno] = useState<string>("0");

    const [diasView, setDiasView] = useState<any[]>([]);

    function carregarDados(escala: any) {
        setRegistrarIntervalo(escala.intervalo_registrar === 1 ? true : false);
        defineCheckBoxInput("escala_banco_horas", escala.escala_banco_horas === 1 ? true : false);
        defineCheckBoxInput("escala_sdf", escala.escala_sdf === 1 ? true : false);
        defineValueInInput("escala_base", escala.escala_base);
        setTipoDiurnoNoturno(String(escala.tipo_diurna_noturna));

        defineValueInInput(`horario_entrada`, escala.horario_entrada);
        defineValueInInput(`horario_saida`, escala.horario_saida);
        if (escala.intervalo_registrar === 1) {
            defineValueInInput(`intervalo_entrada`, escala.intervalo_entrada);
            defineValueInInput(`intervalo_saida`, escala.intervalo_saida);
        }

        defineValueInInput("tolerancia_maxima", escala.tempo_maximo_diario_tolerancia);
        defineValueInInput("tolerancia_entrada_extra", escala.tolerancia_extra_entrada);
        defineValueInInput("tolerancia_entrada_atraso", escala.tolerancia_atraso_entrada);
        defineValueInInput("tolerancia_saida_extra", escala.tolerancia_extra_saida);
        defineValueInInput("tolerancia_saida_atraso", escala.tolerancia_atraso_saida);

        setCalcularHorarioNoturno(escala.horario_noturno);
        if (escala.horario_noturno === 1) {
            defineValueInInput("noturno_inicio", escala.noturno_inicio);
            defineValueInInput("noturno_fim", escala.noturno_fim);
        }
        defineValueInInput("horario_noturno_prorrogado", escala.noturno_prorrogado);
    }

    async function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        event.stopPropagation();
        removeAllErrorMsg();

        const form: any = event.target;
        let formValidado = true;
        let dados = {
            id_escala: Object.values(escala).length === 0 ? null : escala.id_escala,
            codigo: Number(getValueFromInput("codigo")),
            descricao: getValueFromInput("descricao"),
            id_tipo: 2,
            escala_sdf: form.escala_sdf.checked === true ? 1 : 0,
            tipo_diurna_noturna: Number(form.tipo_diurna_noturna.value),
            atualizada: 1,
            data_base: "2022-05-01",
            escala_base: Number(form.escala_base.value),
            escala_banco_horas: form.escala_banco_horas.checked === true ? 1 : 0,
            segunda: null,
            segunda_escala_flexivel: null,
            segunda_gerar_ocorrencias: null,
            segunda_calcular_horas: null,
            segunda_entrada: null,
            segunda_saida: null,
            segunda_intervalo_entrada: null,
            segunda_intervalo_saida: null,
            terca: null,
            terca_escala_flexivel: null,
            terca_gerar_ocorrencias: null,
            terca_calcular_horas: null,
            terca_entrada: null,
            terca_saida: null,
            terca_intervalo_entrada: null,
            terca_intervalo_saida: null,
            quarta: null,
            quarta_escala_flexivel: null,
            quarta_gerar_ocorrencias: null,
            quarta_calcular_horas: null,
            quarta_entrada: null,
            quarta_saida: null,
            quarta_intervalo_entrada: null,
            quarta_intervalo_saida: null,
            quinta: null,
            quinta_escala_flexivel: null,
            quinta_gerar_ocorrencias: null,
            quinta_calcular_horas: null,
            quinta_entrada: null,
            quinta_saida: null,
            quinta_intervalo_entrada: null,
            quinta_intervalo_saida: null,
            sexta: null,
            sexta_escala_flexivel: null,
            sexta_gerar_ocorrencias: null,
            sexta_calcular_horas: null,
            sexta_entrada: null,
            sexta_saida: null,
            sexta_intervalo_entrada: null,
            sexta_intervalo_saida: null,
            sabado: null,
            sabado_escala_flexivel: null,
            sabado_gerar_ocorrencias: null,
            sabado_calcular_horas: null,
            sabado_entrada: null,
            sabado_saida: null,
            sabado_intervalo_entrada: null,
            sabado_intervalo_saida: null,
            domingo: null,
            domingo_escala_flexivel: null,
            domingo_gerar_ocorrencias: null,
            domingo_calcular_horas: null,
            domingo_entrada: null,
            domingo_saida: null,
            domingo_intervalo_entrada: null,
            domingo_intervalo_saida: null,
            horario_entrada: form.horario_entrada.value,
            intervalo_entrada: form.intervalo_entrada.value,
            intervalo_saida: form.intervalo_saida.value,
            horario_saida: form.horario_saida.value,
            intervalo_registrar: form.registrar_intervalo.checked === true ? 1 : 0,
            tempo_maximo_diario_tolerancia: Number(form.tolerancia_maxima.value),
            tolerancia_extra_entrada: Number(form.tolerancia_entrada_extra.value),
            tolerancia_atraso_entrada: Number(form.tolerancia_entrada_atraso.value),
            tolerancia_extra_saida: Number(form.tolerancia_saida_extra.value),
            tolerancia_atraso_saida: Number(form.tolerancia_saida_atraso.value),
            horario_noturno: Number(form.horario_noturno.value),
            noturno_inicio: form.noturno_inicio.value,
            noturno_fim: form.noturno_fim.value,
            noturno_prorrogado: Number(form.horario_noturno_prorrogado.value),
        };

        // Validação Identificação
        if (dados.codigo === 0) {
            showInputErrorMsg("codigo");
            // form.codigo.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.descricao === "") {
            showInputErrorMsg("descricao");
            // form.descricao.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        // Validação Horários
        let horarios_preenchidos = true;
        if (dados.horario_entrada === "") {
            horarios_preenchidos = false;
        }
        if (dados.horario_saida === "") {
            horarios_preenchidos = false;
        }
        if (dados.intervalo_registrar === 1) {
            if (dados.intervalo_entrada === "") {
                horarios_preenchidos = false;
            }
            if (dados.intervalo_saida === "") {
                horarios_preenchidos = false;
            }
        } else {
            dados.intervalo_entrada = null;
            dados.intervalo_saida = null;
        }

        if (!horarios_preenchidos) {
            formValidado = false;
            toast.warning("Necessário informar todos os horários!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }

        // Validação Tempo de Tolerância
        if (dados.tempo_maximo_diario_tolerancia === 0) {
            form.tolerancia_maxima.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tolerancia_extra_entrada === 0) {
            form.tolerancia_entrada_extra.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tolerancia_extra_saida === 0) {
            form.tolerancia_saida_extra.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tolerancia_atraso_entrada === 0) {
            form.tolerancia_entrada_atraso.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tolerancia_atraso_saida === 0) {
            form.tolerancia_saida_atraso.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        // Validação Adicionar Noturno
        if (dados.horario_noturno === 1) {
            if (dados.noturno_inicio === "") {
                form.noturno_inicio.nextElementSibling.style.display = "block";
                formValidado = false;
            }
            if (dados.noturno_fim === "") {
                form.noturno_fim.nextElementSibling.style.display = "block";
                formValidado = false;
            }
        }
        if (dados.horario_noturno === 0) {
            dados.noturno_inicio = null;
            dados.noturno_fim = null;
        }

        console.log(dados);

        if (!formValidado) {
            return;
        }

        if (dados.id_escala === null) {
            await cadastrar(dados);
        }
        if (dados.id_escala > 0) {
            await editar(dados);
        }
    }

    async function cadastrar(dados: any) {
        setLoading(true);
        const api = await reqPut(ApiEndpoints.pontoEscalaCadastrar, dados);
        if (api.status === 201) {
            toast.success("Escala cadastrada com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            window.location.assign(`/ponto/escalas`);
        } else {
            setLoading(false);
        }
    }

    async function editar(dados: any) {
        setLoading(true);
        const api = await reqPatch(ApiEndpoints.pontoEscalaEditar, dados);
        if (api.status === 200) {
            toast.success("Escala editada com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            window.location.assign(`/ponto/escalas`);
        } else {
            setLoading(false);
        }
    }

    function handleChangeHorarioNoturno(event: any) {
        const calcular_noturno = Number(event.target.value);
        setCalcularHorarioNoturno(calcular_noturno);
    }

    async function getDias12x36() {
        let dados = {
            data_base: escala.data_base,
            escala_base: Number(getValueFromInput("escala_base")),
        };
        setLoading(true);
        let api = await reqPostNew(ApiEndpoints.pontoEscalaDias12x36, dados);
        setLoading(false);
        if (api.status === 200) {
            setDiasView(api.data);
        }
    }

    return (
        <div>
            <LoadingModal show={loading} handleClose={() => setLoading(false)} />
            <Form id="formEscalaNormal" onSubmit={handleSubmit} style={{ position: "relative" }} noValidate>
                <Row className="mb-15-forms">
                    <Col className="col-2">
                        <div className="card" id="card-horarios" style={{ width: "18rem", marginRight: "10px" }}>
                            <div className="card-body">
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Entrada
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-entrada" aria-describedby="addon-wrapping" id="horario_entrada" autoComplete="off" placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Saída
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-saida" aria-describedby="addon-wrapping" id="horario_saida" autoComplete={"off"} placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div style={{ display: registrarIntervalo ? "block" : "none" }}>
                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Início Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-entrada" aria-describedby="addon-wrapping" id="intervalo_entrada" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>

                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Fim Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-saida" aria-describedby="addon-wrapping" id="intervalo_saida" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Definições da escala:</Form.Label>
                            <Form.Check type="switch" id="registrar_intervalo" label="Necessário registrar o intervalo" checked={registrarIntervalo} className={stylesCheckbox.inputCheck} onChange={(e) => setRegistrarIntervalo(e.currentTarget.checked)} />
                            <Form.Check type="switch" id="escala_banco_horas" label="Escala com Banco de Horas" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                            <Form.Check type="switch" id="escala_sdf" label="Escala SDF?" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                            <Form.Label>Escala Base:</Form.Label>
                            <Form.Select aria-label="Escala Base - " id="escala_base">
                                <option value="1">Escala - 1</option>
                                <option value="0">Escala - 2</option>
                            </Form.Select>
                            {Object.values(escala).length > 0 && (
                                <div>
                                    <br></br>
                                    <Button variant="info" onClick={() => getDias12x36()}>
                                        Visualizar Escala
                                    </Button>
                                </div>
                            )}
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <ButtonGroup className="mb-2">
                            <ToggleButton id="tipo_diurna" name="tipo_diurna_noturna" type="radio" variant="outline-primary" value={"0"} checked={tipoDiurnoNoturno === "0"} onChange={(e) => setTipoDiurnoNoturno("0")}>
                                Diurno
                            </ToggleButton>
                            <ToggleButton id="tipo_noturna" name="tipo_diurna_noturna" type="radio" variant="outline-primary" value={"1"} checked={tipoDiurnoNoturno === "1"} onChange={(e) => setTipoDiurnoNoturno("1")}>
                                Noturno
                            </ToggleButton>
                        </ButtonGroup>
                    </Col>
                    <Col className="col-2"></Col>
                </Row>

                <Row className="mb-15-forms" style={{ display: diasView.length > 0 ? "flex" : "none", overflowX: "auto" }}>
                    <Col className="col-12 div-row">
                        {diasView.map((dia, idx, arr) => {
                            return (
                                <div key={idx} style={{ marginRight: "10px" }}>
                                    <p>
                                        {dayjs(dia.data).format("DD/MM/YYYY")} {dia.escala}
                                    </p>
                                </div>
                            );
                        })}
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tempo máximo diário de tolerância (minutos):</Form.Label>
                            <Form.Control name="tolerancia_maxima" type="number" id="tolerancia_maxima" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância diário!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tolerância Extra de Entrada (minutos):</Form.Label>
                            <Form.Control name="tolerancia_entrada_extra" type="number" id="tolerancia_entrada_extra" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância extra entrada!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tolerância Atraso de Entrada (minutos):</Form.Label>
                            <Form.Control name="tolerancia_entrada_atraso" type="number" id="tolerancia_entrada_atraso" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância atraso entrada!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tolerância Extra de Saída (minutos):</Form.Label>
                            <Form.Control name="tolerancia_saida_extra" type="number" id="tolerancia_saida_extra" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância extra saída!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tolerância Atraso de Saída (minutos):</Form.Label>
                            <Form.Control name="tolerancia_saida_atraso" type="number" id="tolerancia_saida_atraso" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância atraso saída!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Label>Calcular adicional noturno?</Form.Label>
                        <Form.Select aria-label="Calcular adicional noturno?" value={calcularHorarioNoturno} onChange={(e) => handleChangeHorarioNoturno(e)} id="horario_noturno">
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                        </Form.Select>
                    </Col>
                    <Col className="col-3" style={{ display: calcularHorarioNoturno === 1 ? "block" : "none" }}>
                        <Form.Group>
                            <Form.Label>Horário Noturno Início:</Form.Label>
                            <Form.Control name="noturno_inicio" type="time" id="noturno_inicio" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe o horário de início!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3" style={{ display: calcularHorarioNoturno === 1 ? "block" : "none" }}>
                        <Form.Group>
                            <Form.Label>Horário Noturno Fim:</Form.Label>
                            <Form.Control name="noturno_fim" type="time" id="noturno_fim" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe o horário de fim!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Label>Horário Noturno Prorrogado?</Form.Label>
                        <Form.Select aria-label="Horário Noturno Prorrogado?" id="horario_noturno_prorrogado">
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                        </Form.Select>
                    </Col>
                </Row>

                <Button variant="success" type="submit">
                    Salvar Escala
                </Button>
            </Form>
        </div>
    );
}
interface iProps {
    escala: any;
    handleUpdate: any;
}
